import { IProcedureResponse } from 'clickNgo/models/api'
import { Nullable } from 'cng-common/models/utils'
import { IForm } from 'core-components/classes/models/IForm'

type ProcedureResponse = IProcedureResponse<IForm[]>

// Shared transformResponse helpers: campaign procedures return row arrays, and
// most mutations only care about the first (or all) returned rows.

// Maps the first returned row, or null when the response carries no rows.
export const mapFirstRow =
  <T>(mapper: (row: IForm) => T) =>
  (response: ProcedureResponse): Nullable<T> => {
    if (response.Data && response.Data.length > 0) {
      return mapper(response.Data[0])
    }

    return null
  }

// Maps all returned rows, or an empty array when the response carries no rows.
export const mapRows =
  <T>(mapper: (row: IForm) => T) =>
  (response: ProcedureResponse): T[] => {
    if (response.Data && response.Data.length > 0) {
      return response.Data.map(mapper)
    }

    return []
  }
